import "../scss/style.scss";
import "./anime.js"
import "./index.js"
